import { Button } from "@volvo/vcdk-react";
import type { NavigationButtonsProps } from "../types";
import styles from "./NavigationButtons.module.css";

const NavigationButtons: React.FC<NavigationButtonsProps> = ({
    onNext,
    onBack,
    onSubmit,
    isSubmitDisabled,
}) => (
    <div className={styles.NavigationButtons}>
        {onBack && (
            <Button variant="secondary" onClick={onBack}>
                Back
            </Button>
        )}
        {onNext && (
            <Button variant="primary" onClick={onNext}>
                Next
            </Button>
        )}
        {onSubmit && (
            <Button
                variant="primary"
                onClick={onSubmit}
                disabled={isSubmitDisabled}
            >
                Submit
            </Button>
        )}
    </div>
);

export default NavigationButtons;
